import * as React from "react";
import { Typography, Container } from "@material-ui/core";
import { SecureArea } from "../components/authentication/SecureArea";
import { MemberPermission } from "../services/MemberService";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../services/TelemetryService";

function LotCompletion() {
  return (
    <Container maxWidth={"lg"} fixed>
      <SecureArea memberPermission={MemberPermission.BucketAdmin}>
        <Typography variant="h4" color="primary" gutterBottom>
          Lot Completed
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          The lot has been successfully saved.
        </Typography>
      </SecureArea>
    </Container>
  );
}

export default withAITracking(reactPlugin, LotCompletion, "LotCompletion");
